import type { DocEntityType } from "building-types/doc/docEntityTypes";
import { docEntityTypeToDocTableName } from "./docEntityTypeToDocTableName";
import type { TableBasedDocEntityHandle } from "./tableBasedDocEntityHandle";

export function docEntityHandleIsTableBased<T extends DocEntityType>(handle: {
  readonly type: T;
}): handle is TableBasedDocEntityHandle<T> {
  return docEntityTypeToDocTableName[handle.type] !== undefined;
}
